module.exports = __webpack_public_path__ + "static/media/student.a254cb51.svg";